import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Url, USER_PROFILE_SHOP_SUB_PATHS } from '@wix/da-url';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import PromoBanner from '@wix/da-ds/pkg/PromoBanner';
import PromoBadge from '@wix/da-ds/pkg/Badges/PromoBadge';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { BiData, BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import { getIsAdoptableOfferType } from '../utils/adoptables';
import OfferBanner from './OfferBanner';
import OfferBannerMobile from './OfferBannerMobile';
export const MonetizationStrip = ({ className, deviation, onAdoptableSaleEnd })=>{
    var _deviation_extended, _deviation_extended_adoptable, _deviation_extended1, _deviation_extended2, _deviation, // Adoptables that aren't on sale should show the monetization banners as usual.
    _deviation_adoptable, _deviation_adoptable1, _deviation_adoptable2;
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const isDesktop = !isMobile;
    const isAdoptable = !!((_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.adoptable);
    const offers = (_deviation_extended1 = deviation.extended) === null || _deviation_extended1 === void 0 ? void 0 : (_deviation_extended_adoptable = _deviation_extended1.adoptable) === null || _deviation_extended_adoptable === void 0 ? void 0 : _deviation_extended_adoptable.offers;
    const promo = (_deviation = deviation) === null || _deviation === void 0 ? void 0 : (_deviation_extended2 = _deviation.extended) === null || _deviation_extended2 === void 0 ? void 0 : _deviation_extended2.showStageMonetizationPromo;
    if (isAdoptable && ((_deviation_adoptable = deviation.adoptable) === null || _deviation_adoptable === void 0 ? void 0 : _deviation_adoptable.status) !== 'not_onsale') {
        var _offers;
        if (isDesktop || !deviation.adoptable || !getIsAdoptableOfferType(deviation)) {
            return null;
        }
        if (deviation.adoptable.status === 'sold') {
            return null;
        }
        return /*#__PURE__*/ React.createElement(OfferBannerMobile, _object_spread_props(_object_spread({
            className: className
        }, offers), {
            ownOffer: (_offers = offers) === null || _offers === void 0 ? void 0 : _offers.ownOffer
        }));
    }
    const showOfferBanner = offers && (((_deviation_adoptable1 = deviation.adoptable) === null || _deviation_adoptable1 === void 0 ? void 0 : _deviation_adoptable1.status) === 'onsale' || ((_deviation_adoptable2 = deviation.adoptable) === null || _deviation_adoptable2 === void 0 ? void 0 : _deviation_adoptable2.status) === 'pending');
    if (showOfferBanner) {
        var _offers1;
        return /*#__PURE__*/ React.createElement(OfferBanner, _object_spread_props(_object_spread({}, offers), {
            className: className,
            ownOffer: (_offers1 = offers) === null || _offers1 === void 0 ? void 0 : _offers1.ownOffer,
            deviation: deviation,
            onEnd: onAdoptableSaleEnd
        }));
    }
    // dont show Monetization Strip on mobile
    if (isMobile) {
        return null;
    }
    if (!promo || ![
        'pcp',
        'tier',
        'commission',
        'premium_gallery',
        'adoptable'
    ].includes(promo) || !deviation.author) {
        return null;
    }
    let link = '';
    let biData;
    const commonBiData = {
        typeid: deviation.typeId,
        itemid: deviation.deviationId,
        referral_info: ReferralType.ART_STAGE_PROMOTION,
        section_typeid: deviation.typeId
    };
    if (promo === 'tier') {
        biData = BiData(_object_spread({
            evid: 547,
            sectionname: BiContextProvidedValue
        }, commonBiData));
        link = Url.userSubscriptionsPath({
            username: deviation.author.username
        });
    } else if (promo === 'adoptable') {
        biData = BiData(_object_spread({
            evid: 546,
            sectionname: BiContextProvidedValue
        }, commonBiData));
        link = Url.userShopLink(deviation.author.username, USER_PROFILE_SHOP_SUB_PATHS.ADOPTABLES);
    } else if (promo === 'commission') {
        biData = BiData(_object_spread({
            evid: 548,
            sectionname: BiContextProvidedValue
        }, commonBiData));
        link = Url.userShopLink(deviation.author.username, USER_PROFILE_SHOP_SUB_PATHS.COMMISSIONS);
    } else if (promo === 'premium_gallery') {
        biData = BiData(_object_spread({
            evid: 549,
            sectionname: BiContextProvidedValue
        }, commonBiData));
        link = Url.userShopLink(deviation.author.username, USER_PROFILE_SHOP_SUB_PATHS.PREMIUM_FOLDERS);
    } else if (promo === 'pcp') {
        biData = BiData(_object_spread({
            evid: 557,
            sectionname: BiContextProvidedValue
        }, commonBiData));
        link = Url.userShopLink(deviation.author.username, USER_PROFILE_SHOP_SUB_PATHS.PREMIUM_CONTENT);
    }
    const tPrefix = 'deviationview.artstage.monetizationStrip';
    return /*#__PURE__*/ React.createElement(PromoBanner, {
        className: className,
        size: "small",
        variant: "subscription",
        icon: /*#__PURE__*/ React.createElement(PromoBadge, {
            badgeType: promo,
            size: 16
        }),
        messageAfterIcon: t(`${tPrefix}.var.${promo}.body`),
        ctaLabel: t(`${tPrefix}.var.${promo}.CTA`),
        ctaHref: link,
        ctaBiData: biData
    });
};
MonetizationStrip.displayName = 'MonetizationStrip';
export default MonetizationStrip;
